
import config from '../config/config.json';

const hostQuizCandidato = config.production.hostQuizCandidato;

/* URL LOGO */
export const urlLogo = hostQuizCandidato + "/logowebapp.png";